import { useSelector } from 'react-redux';

import ItemEditable from 'common/components/items/ItemEditable';
import { useLocalization } from 'redux/localization/utils/hooks';

const Items = () => {
  const cart = useSelector((state) => state.cart.data);
  const { t } = useLocalization();
  return (
    <>
      <div className="c7-order-items c7-order-items--cart">
        <h2 className="c7-sr-only c7-h2">
          {t('general.accessibility.orderItems')}
        </h2>
        <ul>
          {cart.items.map((item) => (
            <ItemEditable item={item} key={item.id} />
          ))}
        </ul>
      </div>
    </>
  );
};

export default Items;
